<template>
<div>
<el-row>
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="title">
<h1>V-ray渲染：SSS+PBR材质</h1>
</div>
<div class="picture">
<img src="../assets/project4_1.gif"/>
</div>
<div class="abstract">
                    环境：Vray for max
                </div> </el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="9">
<div class="picture">
<img src="../assets/bunny-pbr2.jpg.webp"/>
</div>
</el-col>
<el-col :span="11">
<div class="picture">
<img src="../assets/project4_2.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="10">
<div class="picture">
<img src="../assets/project4_3.jpg.webp"/>
<br/><br/> <br/><img src="../assets/project4_5.jpg.webp"/>
<br/><br/><br/> <img src="../assets/project4_6.jpg.webp"/>
<br/> <br/><br/><img src="../assets/project4_9.jpg.webp"/>
</div>
</el-col>
<el-col :span="10">
<div class="picture">
<img src="../assets/project4_4.jpg.webp"/>
<br/> <br/><br/> <img src="../assets/project4_7.jpg.webp"/>
<br/> <br/><br/> <img src="../assets/project4_8.jpg.webp"/>
<br/> <br/><br/> <img src="../assets/project4_10.jpg.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
</div>
</template>

<script>
    export default {
        name: "Project1Zh"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>